// extracted by mini-css-extract-plugin
module.exports = {"main-component":"selectedTaskCheckBox_main-component__v66XO"};